import { createIconComponent } from '../../factory/create-icon-component';
export const RedoIcon = createIconComponent(
  'RedoIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 15V7M22 15H14.2222M22 15C22 15 17 7 11 7C2.99997 7 1.99997 15 1.99997 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
